<template>
<v-app>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div v-if="data_not_found === false">
            <div class="pt-3 px-3 pab_purchase_order_detail_list">
                <div class="mb-3">
                    <div class="d-flex justify-center align-center flex-column">
                        <div class="img_title_purchase_order_detail_list">
                            <img :src="beforeImage">
                        </div>
                        <h3>ใบสั่งซื้อสินค้า</h3>
                    </div>
                </div>
                <div class="data_list_purchase_order_detail_list">

                    <div class="detail_purchase_order_detail_list" v-for="(detail_title,key_title) in data" :key="key_title">
                        <v-card>
                            <div class="header_data_list_purchase_order_detail_list white--text text-center pa-3">
                                {{ detail_title.source_name }}
                            </div>
                            <div>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="text-center">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    รายการ
                                                </div>
                                            </th>
                                            <th class="text-center">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    ซื้อ
                                                </div>
                                            </th>
                                            <th class="text-center">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    หน่วยนับ
                                                </div>
                                            </th>
                                            <th class="text-center">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    ราคาต่อหน่วย
                                                </div>
                                            </th>
                                            <th class="text-center">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    ราคารวม
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(detail_subtitle,key_subtitle) in detail_title.typeList" :key="key_subtitle">
                                        <tr class="subtitle_data_list_purchase_order_detail_list">
                                            <td colspan="5">
                                                <div class="font_size_table_purchase_order_detail_list">
                                                    {{ detail_subtitle.type_name }}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-for="(detail_description,key_description) in detail_subtitle.detailList" :key="key_description">
                                            <td class="text-center" width="40%">
                                                <div class="pa-2 font_size_table_purchase_order_detail_list">
                                                    {{ detail_description.mat_name }}
                                                </div>

                                            </td>
                                            <td class="text-center" width="10%">
                                                <div class="pa-2 font_size_table_purchase_order_detail_list">
                                                    {{ detail_description.quantity }}
                                                </div>

                                            </td>
                                            <td class="text-center" width="10%">
                                                <div class="pa-2 font_size_table_purchase_order_detail_list">
                                                    {{ detail_description.unit_name }}
                                                </div>

                                            </td>
                                            <td class="text-center" width="20%">
                                                <div class="pa-2 font_size_table_purchase_order_detail_list">
                                                    {{ detail_description.price }}
                                                </div>

                                            </td>
                                            <td class="text-center" width="20%">
                                                <div class="pa-2 font_size_table_purchase_order_detail_list">
                                                    {{ detail_description.total }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                        </v-card>
                    </div>

                    <hr class="line_detail_purchase_order_detail_list">

                </div>
            </div>
        </div>
    </div>
    <div v-if="data_not_found === true" class="d-flex justify-center align-center flex-column data_not_found_purchase_order_detail_list">
        <div class="d-flex justify-center align-center">
            <div class="img_title_purchase_order_detail_list mr-1">
                <img src="@/assets/new-logo.png">
            </div>
            <h2>ไม่มีข้อมูลใบสั่งซื้อสินค้า</h2>
        </div>
    </div>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logologinandtkfull.png";
import stockpurchaseorder from '@/api/stock/stocklist/stockpurchaseorder.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            beforeImage: before_image,
            data_not_found: false,
            data: [],
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get('/showColorAdmin', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.beforeImage = response.data.logo_image
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async purchaseOrderDetail() {
            this.loading_page = true
            this.data = []
            stockpurchaseorder.purchaseOrderDetail(this.$route.params.id).then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.sourceList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status !== 401) {
                    this.data_not_found = true
                    this.loading_page = false
                }
            })
        },

    },
    mounted() {
        this.colorRestaurant()
        this.purchaseOrderDetail()
    }
}
</script>

<style scoped>
.pab_purchase_order_detail_list {
    padding-bottom: 80px;
}

.img_title_purchase_order_detail_list {
    width: 100px;
}

.img_title_purchase_order_detail_list>img {
    max-width: 100%;
}

.data_list_purchase_order_detail_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 10px 0;
}

.font_size_table_purchase_order_detail_list {
    font-size: 16px;
}

.line_detail_purchase_order_detail_list {
    margin: 10px 0;
}

.line_detail_purchase_order_detail_list:last-child {
    display: none;
}

.header_data_list_purchase_order_detail_list {
    background: #272727;
}

.subtitle_data_list_purchase_order_detail_list,
.subtitle_data_list_purchase_order_detail_list:hover {
    background: #bebebe !important;
}

.data_not_found_purchase_order_detail_list {
    height: 100%;
}
</style>
